import { render, staticRenderFns } from "./task.vue?vue&type=template&id=0c2a780d&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=0c2a780d&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=0c2a780d&prod&lang=scss&scoped=true&external"
import style2 from "./task.vue?vue&type=style&index=2&id=0c2a780d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a780d",
  null
  
)

export default component.exports